import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import CardJourneyBar from "../cardJourneyBar";
import * as S from "../dashboard/_shared";
import Tag from "../tag";
import { formatMeta, metaDefinida } from "../../utils/meta";
import "./style.scss";

export default function CardJourney({ element, onSel, sel }) {
  const { C, F, JCFG, JICONS, etSt } = S;

  const { category, name, target, unimed_system, value, value_delta } =
    element || {};

  const dist = {
    ms: element.opcao_5,
    s: element.opcao_4,
    r: element.opcao_3,
    i: element.opcao_2,
    mi: element.opcao_1,
  };

  const distC = {
    ef: element.opcao_5,
    f: element.opcao_4,
    n: element.opcao_3,
    d: element.opcao_2,
    ed: element.opcao_1,
  };

  const st = etSt(name, value);
  const isCes = category === "ces";
  const isPositive = value_delta > 0;
  const isNegative = value_delta < 0;
  const IconComp = JICONS[name];
  const hasDist = isCes ? !!dist : !!distC;

  return (
    <div
      className={`compCardJourney${sel ? " is-selected" : ""}`}
      style={{
        "--_color": st.color,
        "--_bg": sel ? st.bg || C.greenBg : C.surface,
      }}
      onClick={() => onSel(element.name)}
    >
      {/* Icon + badge */}
      <div className="header">
        <div
          className="icon-wrap"
          style={{ "--_icon-bg": isCes ? C.blueBg : C.greenBg }}
        >
          {IconComp && (
            <IconComp
              size={17}
              color={isCes ? C.blue : C.g700}
              strokeWidth={1.8}
            />
          )}
        </div>
        <span
          className="badge"
          style={{
            "--_accent": isCes ? C.blue : C.g700,
            "--_icon-bg": isCes ? C.blueBg : C.greenBg,
          }}
        >
          {isCes ? "CES" : "CSAT"}
        </span>
      </div>
      {/* Name */}
      <div className="name">{name}</div>
      {/* Big number */}
      <div className="value">{value}%</div>
      <div className="meta-line">Meta {formatMeta(target, "%")}</div>
      <div className="unimed-line">Sist. Unimed {unimed_system}%</div>
      {/* Distribution bar */}
      {hasDist && (
        <div className="dist-wrap">
          <CardJourneyBar dist={isCes ? distC : dist} tipo={category} small />
        </div>
      )}
      {/* Progress bar */}
      <div className="progress-track">
        {metaDefinida(target) !== null && (
          <div
            className="progress-target"
            style={{ "--_target-pct": `${target}%` }}
          />
        )}
        <div
          className="progress-fill"
          style={{ "--_value-pct": `${Math.min(value, 100)}%` }}
        />
      </div>
      {/* Status badge */}
      <div className="footer">
        <div>
          <Tag label={st.label} color={st.color} bg={st.bg} />
        </div>
        {value_delta !== undefined && (
          <div
            className="delta"
            style={{
              "--_delta-color": isPositive
                ? C.green
                : isNegative
                  ? C.red
                  : C.text,
            }}
          >
            {isPositive && <ArrowUpRight size={13} />}
            {isNegative && <ArrowDownRight size={13} />}
            <span>
              {isPositive ? "+" : ""}
              {value_delta}pp
            </span>
            <span className="delta-period"></span>
          </div>
        )}
      </div>
    </div>
  );
}
